<template>
  <v-dialog class="custom-dialog-wrapper" v-model="dialog" max-width="600px">
    <v-card color="universal-vcard">
      <v-card-title class="d-flex justify-space-between align-center">
        <a @click="close" class="popup-close-icon-wrapper"
          ><img src="@/assets/img/entry_form_close.svg"
        /></a>
      </v-card-title>
      <v-card-text>
        <div class="popup-content-wrapper">
          <div class="vrste-evenata-wrapper">
            <div :class="'vrsta-eventa event-green'">
              {{ selectedCategory.name }}
            </div>
            <div
              :class="'vrsta-eventa event-blue'"
              v-for="tag in knowledge.tags"
              :key="tag"
            >
              #{{ tag }}
            </div>
          </div>

          <div class="title-edit-wrapper">
            <div class="kalendar-event-title">
              {{ knowledge.title }}
            </div>
          </div>
          <div>
            <div class="section-divider"></div>
            <div class="sudionici-eventa simple-text-popup">
              <div class="event-participants-wrapper">
                <div class="section-name">{{ $t('components.knowledge_management.detail_dialog.description') }}</div>
                <div class="opis-text status-text">
                  <span>{{ knowledge.description }}</span>
                </div>
              </div>
            </div>
            <div class="section-divider"></div>
            <div class="sudionici-eventa simple-text-popup">
              <div class="event-participants-wrapper">
                <div class="section-name">{{ $t('components.knowledge_management.detail_dialog.created_by') }}</div>
                <router-link :to="'/osobe/law/'+knowledge.updates[0].user_id " class="opis-text event-participant-popup">
                  <span>{{ knowledge.updates[0].user_name }}</span>
                </router-link>
              </div>
            </div>

            <div class="section-divider"></div>
            <div class="sudionici-eventa simple-text-popup">
              <div class="event-participants-wrapper">
                <div class="section-name">{{ $t('components.knowledge_management.detail_dialog.last_edited') }}
                </div>
                <router-link :to="'/osobe/law/'+knowledge.updates[knowledge.updates.length-1].user_id " class="opis-text event-participant-popup">
                  <span>{{ knowledge.updates[knowledge.updates.length-1].user_name }}</span> <span>({{ getTimestamp(knowledge.updates[knowledge.updates.length-1].timestamp) }})</span>
                </router-link>
              </div>
            </div>

            <div
              v-if="
                files.length > 0
              "
              class="simple-text-popup"
            >
              <div class="section-divider"></div>
              <div class="sudionici-eventa">
                <div class="event-participants-wrapper">
                  <div class="section-name">
                   {{ $t('components.knowledge_management.detail_dialog.attachments') }}
                  </div>
                  <div class="event-participants align-participants">
                    <a
                      v-for="(file, key) in files"
                      :key="key"
                      class="event-attachment"
                      :href="file['@microsoft.graph.downloadUrl']" target="_blank"
                      >{{ file.name }}</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
      </v-card-text>
      <v-form>
        <div class="vdialog-buttons-wrapper wrapper-three-buttons">
          <div
            class="universal-vdialog-button vbutton-secondary"
            @click="close"
          >
            {{ $t("repetitive.okay") }}
          </div>
          
        </div>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import graph from '@/services/graph'
import moment from 'moment';

export default {
  name: "KnowledgeDetailDialog",
  props: {},
  data() {
    return {
      dialog: false,
      selectedCategory: null,
      knowledge: null,
      files : []
    };
  },
  computed: {
    categoryName() {
      return this.selectedCategory;
    },
  },
  methods: {
    getTimestamp(ts)
    {
      return moment(ts).format("lll")
    },
   async open(know, cat) {
      this.knowledge = know;
      this.selectedCategory = cat;
      this.files = await graph.getMultipleFiles(know.links);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.knowledge-dialog .v-card {
  overflow: hidden;
}
</style>
